/* MEK - interacciones de la landing */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.mkl-rv, .mkl-rv-mask');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { if (!e.classList.contains('is-in')) io.observe(e); });
  }

  function tickers(root) {
    (root || document).querySelectorAll('.mkl-ticker__track').forEach(function (track) {
      if (track.dataset.mklCloned) return;
      var group = track.querySelector('.mkl-ticker__group');
      if (!group) return;
      track.appendChild(group.cloneNode(true));
      track.dataset.mklCloned = '1';
    });
  }

  function videos(root) {
    (root || document).querySelectorAll('.mkl-ig-tile[data-video]').forEach(function (tile) {
      if (tile.dataset.mklBound) return;
      tile.dataset.mklBound = '1';
      var v = tile.querySelector('video');
      if (!v) return;
      var play = function () {
        tile.classList.add('is-playing');
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };
      var stop = function () {
        tile.classList.remove('is-playing');
        try { v.pause(); v.currentTime = 0; } catch (e) {}
      };
      tile.addEventListener('mouseenter', play);
      tile.addEventListener('mouseleave', stop);
      tile.addEventListener('focusin', play);
      tile.addEventListener('focusout', stop);
      if ('IntersectionObserver' in window && window.matchMedia('(max-width: 1024px)').matches) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { e.isIntersecting && e.intersectionRatio > 0.65 ? play() : stop(); });
        }, { threshold: [0, 0.65, 1] }).observe(tile);
      }
    });
  }

  function parallax() {
    if (reduce) return;
    var media = document.querySelectorAll('[data-mkl-parallax]');
    if (!media.length) return;
    var ticking = false;
    function run() {
      media.forEach(function (m) {
        var r = m.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var p = (r.top / window.innerHeight) * 40;
        m.style.transform = 'translate3d(0,' + p.toFixed(2) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(run); }
    }, { passive: true });
    run();
  }

  function init(root) { reveal(root); tickers(root); videos(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); parallax(); });
  } else { init(); parallax(); }

  // Compatibilidad con el editor de temas de Shopify
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();
